<div class="case-item">
  <div class="patient-img">
    @if (url !== 'icon') {
      <img alt="patient image" class="profile-img" defaultImage="/assets/images/loader1.gif" [lazyLoad]="url" />
    } @else {
      <mat-icon class="profile-icon">account_box</mat-icon>
    }
  </div>
  <div class="information">
    <div class="case-title">{{ case.title }}</div>
    <div class="patient-name">{{ getPatientProperty('zoeknaam', case.patient) }}</div>
  </div>
</div>
